import { Component, DestroyRef, inject, NgZone } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Store } from '@ngxs/store';
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { ApplicationSelectors } from '../../../shared/store/application/application.selectors';

const LOADER_HIDE_GRACE_MS = 250;

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [NgxSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  protected readonly spinnerTemplate = `
    <div class="loader-screen d-flex align-items-center justify-content-center">
      <div class="loader-screen-dots d-flex align-items-center justify-content-center gap-2">
        <span class="loader-screen-dot" data-variant="primary"></span>
        <span class="loader-screen-dot" data-variant="secondary"></span>
        <span class="loader-screen-dot" data-variant="tertiary"></span>
      </div>
    </div>
  `;

  private readonly store = inject(Store);
  private readonly ngZone = inject(NgZone);
  private readonly spinner = inject(NgxSpinnerService);
  private readonly destroyRef = inject(DestroyRef);
  private hideTimerId: ReturnType<typeof setTimeout> | null = null;

  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.hideTimerId !== null) {
        clearTimeout(this.hideTimerId);
      }
    });

    this.store
      .select(ApplicationSelectors.loader)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((map: Map<string, boolean>) => {
        this.ngZone.run(() => {
          if (map.size > 0) {
            if (this.hideTimerId !== null) {
              clearTimeout(this.hideTimerId);
              this.hideTimerId = null;
            }

            this.spinner.show('main');
            return;
          }

          if (this.hideTimerId !== null) {
            return;
          }

          this.hideTimerId = setTimeout(() => {
            this.hideTimerId = null;
            this.spinner.hide('main');
          }, LOADER_HIDE_GRACE_MS);
        });
      });
  }
}
